import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import useControlAttribute from "../../../hooks/useControlAttribute";
import { IControlBase } from "../types";

export type TValueItem<T> = {
  name: string;
  attribute: T;
  unit?: string;
};

interface IValueRowProps<T> {
  control: IControlBase;
  item: TValueItem<T>;
}

function ValueRow<T>(props: IValueRowProps<T>) {
  const { control, item } = props;
  return (
    <TableRow>
      <TableCell>{item.name}</TableCell>
      <TableCell>
        {useControlAttribute(control, item.attribute as string)}
        {item.unit}
      </TableCell>
    </TableRow>
  );
}

interface IValueTableProps<T> {
  control: IControlBase;
  items: TValueItem<T>[];
}

export default function ValueTable<T>(props: IValueTableProps<T>) {
  const { control, items } = props;
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableBody>
          {items.map((item, index) => (
            <ValueRow key={index} control={control} item={item} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
